export enum Param {
  Currency = "Destination Currency:ISOCode",
  Date = "Date:ActualDate",
  PortfolioType = "Performance:PortfolioType",
  Investor = "Performance:InvestorName",
  Fund = "Performance:FundName",
  MandateFund = "Performance:MandateFund",
}
